<template>
  <v-navigation-drawer
    v-model="open"
    width="300"
    fixed
    clipped
    app
    dark
    class="grey darken-3"
  >
    <template v-slot:prepend>
      <v-list-item @click="handleHomeClick()">
        <v-list-item-icon>
          <v-icon>fa-home</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Inicio</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
    <v-divider></v-divider>

    <v-list class="py-0" v-if="esAdmin" expand>
      <v-list-item :to="{ name: 'Administracion' }" color="primary">
        <v-list-item-icon>
          <v-icon>fa-user-shield</v-icon>
        </v-list-item-icon>
        <v-list-item-title>Admin</v-list-item-title>
      </v-list-item>
      <v-divider></v-divider>
    </v-list>

    <v-list class="py-0" expand>
      <v-list-group prepend-icon="fa-cog" value="true">
        <template v-slot:activator>
          <v-list-item>
            <v-list-item-title>Configuración</v-list-item-title>
          </v-list-item>
        </template>

        <v-list-item
          v-for="configuracion in configuracionAgroList"
          :key="configuracion.title"
          :to="{ name: configuracion.route }"
        >
          <v-list-item-icon>
            <v-icon>{{ configuracion.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ configuracion.title }}</v-list-item-title>
        </v-list-item>
      </v-list-group>

      <v-divider></v-divider>

      <v-list-group prepend-icon="fa-sync-alt" value="true">
        <template v-slot:activator>
          <v-list-item>
            <v-list-item-title>Actividades</v-list-item-title>
          </v-list-item>
        </template>

        <v-subheader>Ficha</v-subheader>

        <fh-menu-ficha-agricola v-if="isAgricultorSet"></fh-menu-ficha-agricola>

        <v-list-item :to="{ name: 'Precipitacion' }">
          <v-list-item-icon>
            <v-icon>fa-vial</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Precipitación</v-list-item-title>
        </v-list-item>

        <v-subheader>Actividades</v-subheader>

        <v-list-item
          v-for="rubro in listaRubro"
          :key="rubro.idRubro"
          :to="{ name: 'Actividad', params: { rubroSlug: rubro.rubroSlug } }"
        >
          <v-list-item-icon>
            <v-icon>fa-{{ rubro.icono }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ rubro.nombre }}</v-list-item-title>
        </v-list-item>

        <v-list-item :to="{ name: 'RendimientoCosecha' }">
          <v-list-item-icon>
            <v-icon>fa-file-invoice-dollar</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Rendimiento cosecha</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item :to="{ name: 'Alquiler' }">
          <v-list-item-icon>
            <v-icon>fa-hand-holding-usd</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Alquiler</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>

      <v-divider></v-divider>

      <v-list-item :to="{ name: 'Resumen' }" color="primary">
        <v-list-item-icon>
          <v-icon>fa-chart-bar</v-icon>
        </v-list-item-icon>
        <v-list-item-title>Resumen</v-list-item-title>
      </v-list-item>

      <v-divider v-if="esAdmin"></v-divider>

      <v-list-group v-if="esAdmin" prepend-icon="fa-chart-line" value="true">
        <template v-slot:activator>
          <v-list-item>
            <v-list-item-title>Estadisticas</v-list-item-title>
          </v-list-item>
        </template>

        <v-list-item :to="{ name: 'EstadisticasGanaderia' }" color="primary">
          <v-list-item-icon>
            <v-icon>fa-solid fa-chart-column</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Estadísticas ganadería</v-list-item-title>
        </v-list-item>

        <v-list-item :to="{ name: 'Estadisticas' }" color="primary">
          <v-list-item-icon>
            <v-icon>fas fa-chart-area</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Estadísticas agricultura</v-list-item-title>
        </v-list-item>
      </v-list-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import FhMenuFichaAgricola from "@/components/app/FhMenuFichaAgricola";
export default {
  name: "FhAgroNavDrawer",
  props: {
    drawer: Boolean,
  },
  components: {
    FhMenuFichaAgricola,
  },
  data() {
    return {
      open: true,
      configuracionAgroList: [
        { title: "Máquinas", icon: "fa-tractor", route: "Maquinas" },
        { title: "Personal", icon: "fa-users", route: "Personal" },
        { title: "Productos", icon: "fa-flask", route: "Productos" },
        { title: "Fichas", icon: "fa-file-alt", route: "Fichas" },
      ],
    };
  },
  computed: {
    ...mapState("admin", ["esAdmin"]),
    ...mapState("rubros", ["listaRubro"]),
    ...mapGetters("establecimientos", [
      "isEstablecimientoSet",
      "currentCategoria",
      "hasCategoriaAgricultura",
    ]),
    ...mapGetters("agricultor", ["isOnlyOperador", "isAgricultorSet"]),
    isRestrictedView() {
      return (
        this.$route.name === "ElegirAgricultor" ||
        this.$route.name === "CrearEstablecimiento"
      );
    },
  },
  watch:{
    drawer(){
      this.open = this.drawer
    }
  },
  methods: {
    handleHomeClick() {
      if (this.currentCategoria === 1) {
        this.$router.push({ name: "AgroHome" }).catch(() => {});
      } else {
        this.$router.push({ name: "GanaderiaHome" }).catch(() => {});
      }
    },
  },
};
</script>

<style>
</style>